/*
 * R44 Performance — Tuning configurator add-on
 * - Clicking a Stage card pre-answers the hardware steps for that stage and jumps into the builder
 * - Shows the car PNG at the top of the "Your package" panel
 * - Last step: "Send enquiry" (emails the full build via the contact form) + "Checkout now"
 * Loads after r44-tuning-configurator.js and extends it.
 */
(function () {
  'use strict';
  var C = window.R44TuningConfigurator;
  if (!C || C.prototype.startStage) return;
  var P = C.prototype;

  function arr(a) { return Array.isArray(a) ? a : []; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  P.startStage = function (idx) {
    var self = this, stg = arr(this.d.stages)[idx];
    if (!stg) return;
    var req = {};
    arr(stg.requires).forEach(function (k) { req[String(k).trim()] = true; });
    var softwareOnly = !arr(stg.requires).length;
    this.activeSteps().forEach(function (st) {
      if (!st.key) return; // e.g. drop-off: always the customer's choice
      var s = self.selOf(st);
      if (s.mode === 'fitted') return; // never undo "already fitted"
      if (req[st.key]) {
        if (s.mode === 'products' && Object.keys(s.items).length) return; // keep their own pick
        var first = self.visible(st)[0];
        s.mode = null; s.items = {};
        if (first) self.pick(st, first.id); // recommended part = first in the list
      } else if (softwareOnly) {
        if (st.allowSkip) { s.mode = 'skip'; s.items = {}; }
      } else if (s.mode === 'skip') {
        s.mode = null; // optional extras: let them choose
      }
    });
    this.state.started = { name: stg.name, soft: softwareOnly };
    this.go(0);
  };

  // Clear the "Stage selected" note once they move on
  var go = P.go;
  P.go = function (i) {
    if (i > 0 && this.state.started) this.state.started = null;
    return go.call(this, i);
  };

  // Note on the first step after a Stage card was clicked
  var renderPanel = P.renderPanel;
  P.renderPanel = function () {
    renderPanel.call(this);
    var st = this.state;
    if (st.step !== 0 || !st.started || !st.started.name) return;
    var panel = this.el.querySelector('[data-r44t-panel]');
    if (!panel) return;
    var note = document.createElement('p');
    note.className = 'r44t-nudge r44t-nudge--start';
    note.innerHTML = '<strong>' + esc(st.started.name) + ' selected.</strong> ' +
      (st.started.soft
        ? 'It\'s software only, so we\'ve marked the hardware steps as not needed.'
        : 'We\'ve pre-picked the hardware it needs. You can swap brands or mark parts as already fitted on the next steps.') +
      ' Tell us about your car to continue.';
    panel.insertBefore(note, panel.firstChild);
  };

  // Car image at the top of the package summary
  var renderSide = P.renderSide;
  P.renderSide = function () {
    renderSide.call(this);
    var img = this.cfg && this.cfg.carImage;
    var side = this.el.querySelector('[data-r44t-side]');
    if (!img || !side) return;
    side.insertAdjacentHTML('afterbegin', '<img class="r44t-side__img" src="' + esc(img) + '" alt="' + esc(this.p.name) + '" width="500" height="250">');
  };
  var renderSide2 = P.renderSide;
  P.renderSide = function () {
    renderSide2.call(this);
    var side = this.el.querySelector('[data-r44t-side]');
    if (side) side.insertAdjacentHTML('afterbegin', '<button type="button" class="r44t-sheet__close" data-r44t-sheet>Close &#10005;</button>');
  };

  // Last step: "Send enquiry" + "Checkout now" instead of a single add-to-basket button.
  // Phones get their own bottom bar: back, package total (opens the summary sheet) and the main action.
  var renderNav = P.renderNav;
  P.renderNav = function () {
    renderNav.call(this);
    var i = this.state.step, last = i === this.steps.length - 1;
    var ready = this.firstInvalid() === -1 && this.stage() && this.stage().variant;
    var valid = this.stepValid(i);
    if (last) {
      this.cfg.afterAdd = 'checkout';
      var nav = this.el.querySelector('[data-r44t-nav]');
      if (nav) {
        nav.innerHTML = '<button type="button" class="r44t-btn r44t-btn--ghost" data-back>Back</button>' +
          '<div class="r44t-nav__end">' +
            '<button type="button" class="r44t-btn r44t-btn--ghost" data-r44t-enquire>Send enquiry</button>' +
            '<button type="button" class="r44t-btn r44t-btn--primary" data-add' + (ready ? '' : ' disabled') + '>Checkout now</button>' +
          '</div>';
      }
    }
    var mb = this.el.querySelector('[data-r44t-mbar]');
    if (!mb) return;
    var stg = this.stage();
    mb.innerHTML =
      (i > 0 ? '<button type="button" class="r44t-mbar__back" data-back aria-label="Back">&#8249;</button>' : '') +
      '<button type="button" class="r44t-mbar__sum" data-r44t-sheet aria-label="View your package">' +
        '<small>' + esc(stg ? stg.name : 'Your package') + '</small>' +
        '<strong>' + this.fmt(this.total()) + '</strong>' +
        '<span>View package</span>' +
      '</button>' +
      (last
        ? '<button type="button" class="r44t-btn r44t-btn--primary" data-add' + (ready ? '' : ' disabled') + '>Checkout</button>'
        : '<button type="button" class="r44t-btn r44t-btn--primary" data-next' + (valid ? '' : ' disabled') + '>Continue</button>');
  };

  // Phone: step counter + progress bar instead of the row of step tabs
  var renderProgress = P.renderProgress;
  P.renderProgress = function () {
    renderProgress.call(this);
    var ol = this.el.querySelector('[data-r44t-progress]');
    if (!ol) return;
    var box = this.el.querySelector('.r44t-mstep');
    if (!box) {
      box = document.createElement('div');
      box.className = 'r44t-mstep';
      ol.parentNode.insertBefore(box, ol);
    }
    var n = this.steps.length, i = this.state.step;
    box.innerHTML = '<div class="r44t-mstep__top"><span>Step ' + (i + 1) + ' of ' + n + '</span><strong>' + esc(this.steps[i].title) + '</strong></div>' +
      '<div class="r44t-mstep__bar"><i style="width:' + Math.round(((i + 1) / n) * 100) + '%"></i></div>';
  };

  // Review step on phones: "Send enquiry" as a full-width button under the total
  var renderPanelR = P.renderPanel;
  P.renderPanel = function () {
    renderPanelR.call(this);
    if (this.state.step !== this.steps.length - 1) return;
    var panel = this.el.querySelector('[data-r44t-panel]');
    if (panel) panel.insertAdjacentHTML('beforeend',
      '<div class="r44t-review__m"><button type="button" class="r44t-btn r44t-btn--ghost r44t-btn--block" data-r44t-enquire>Send enquiry instead</button>' +
      '<p class="r44t-muted">We\'ll email your package to our sales team. Nothing is charged.</p></div>');
  };

  // Phone summary sheet
  function closeSheet(c) { if (c && c.el.classList.contains('is-sheet')) { c.el.classList.remove('is-sheet'); document.documentElement.classList.remove('r44t-lock'); } }
  var goS = P.go;
  P.go = function (i) { closeSheet(this); return goS.call(this, i); };

  // Full details in the enquiry / consultant email
  var summary = P.summary;
  P.summary = function () {
    var d = this.state.details || {}, extra = [];
    if (d.vin) extra.push('VIN: ' + String(d.vin).toUpperCase());
    if (d.phone) extra.push('Phone: ' + d.phone);
    if (d.date) extra.push('Preferred drop-off: ' + d.date);
    var out = summary.call(this);
    return extra.length ? out + '\n' + extra.join('\n') : out;
  };

  // Enquiry = the consultant form, worded as an enquiry and pre-filled
  var openModal = P.openModal, enquiry = false;
  P.openModal = function () {
    var m = this.modal();
    openModal.call(this);
    if (!m) return;
    var h = m.querySelector('#r44t-modal-h'), lead = m.querySelector('.r44t-modal__lead'), send = m.querySelector('[data-r44t-send]'),
        type = m.querySelector('[name="contact[Enquiry]"]'), phone = m.querySelector('[name="contact[phone]"]');
    [h, lead, send, type].forEach(function (n) { if (n && n.__orig == null) n.__orig = n.tagName === 'INPUT' ? n.value : n.textContent; });
    function set(n, v) { if (!n) return; if (n.tagName === 'INPUT') n.value = v; else n.textContent = v; }
    if (enquiry) {
      set(h, 'Send your enquiry');
      set(lead, 'We\'ll send your full package and car details to our sales team, who will confirm fitment, pricing and drop-off dates with you. Nothing is charged.');
      set(send, 'Send enquiry');
      set(type, 'Tuning enquiry — ' + this.p.name + ' — ' + this.state.buildId);
      var d = this.state.details || {};
      if (phone && !phone.value && d.phone) phone.value = d.phone;
    } else {
      [h, lead, send, type].forEach(function (n) { if (n && n.__orig != null) set(n, n.__orig); });
    }
    enquiry = false;
  };
  P.openEnquiry = function () { enquiry = true; this.openModal(); };

  function instance() {
    var el = document.querySelector('[data-r44t-config]');
    return el && el.__r44t;
  }
  function start(e) {
    var sc = e.target.closest && e.target.closest('[data-r44t-start-stage]');
    if (!sc) return;
    var c = instance();
    if (!c) return;
    e.preventDefault();
    c.startStage(+sc.getAttribute('data-r44t-start-stage'));
  }
  document.addEventListener('click', start);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r44t-enquire]');
    if (!b) return;
    var c = instance();
    if (c) { e.preventDefault(); c.openEnquiry(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') start(e); });
  document.addEventListener('click', function (e) {
    var c = instance();
    if (!c) return;
    var t = e.target.closest && e.target.closest('[data-r44t-sheet]');
    if (t) {
      e.preventDefault();
      var open = !c.el.classList.contains('is-sheet');
      c.el.classList.toggle('is-sheet', open);
      document.documentElement.classList.toggle('r44t-lock', open);
      return;
    }
    if (e.target === c.el && c.el.classList.contains('is-sheet')) closeSheet(c); // tap on the dimmed backdrop
  });

  // Only show the phone bottom bar while the builder is on screen (and lift the chat bubble above it)
  function watch() {
    var c = instance();
    if (!c || !('IntersectionObserver' in window)) { if (c) c.el.classList.add('is-inview'); return; }
    var sec = document.getElementById('r44t-configurator') || c.el;
    new IntersectionObserver(function (en) {
      var on = en[0].isIntersecting;
      c.el.classList.toggle('is-inview', on);
      document.body.classList.toggle('r44t-mbar-on', on);
    }, { rootMargin: '0px 0px -30% 0px' }).observe(sec);
  }

  // Re-render any builder that started before this file loaded
  function refresh() { var c = instance(); if (c) { c.render(); watch(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
